import { useCallback, useEffect, useState } from "react";
import { Button, Col, Divider, Modal, notification, Row } from "antd";
import SummaryTable from "./SummaryTable";
import PositionsControls from "./PositionsControls";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../../../../../context/LanguageContext";
import { ClassesShow, PositionSecured } from "../../../../../../models/Security";
import SecurityService from "../../../../../../services/SecurityService";

interface PositionsProps {
  positionSecured: PositionSecured[];
  classes: ClassesShow[];
}

const Positions = (props: PositionsProps) => {
  const { language } = useLanguage();
  const { sweepId } = useParams();
  const [positionFilter, setPositionFilter] = useState<string>("");
  const [palletFilter, setPalletFilter] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string[]>([]);


  const onApplyFilters = useCallback(
    (
      position: string,
      pallet: string,
      status: string[]
    ) => {
      setPositionFilter(position);
      setPalletFilter(pallet);
      setStatusFilter(status);
    },
    []
  );

  const trimSpacesInPositionLabels = (untrackedPositions: PositionSecured[]): PositionSecured[] => {
    return untrackedPositions.map(position => {
      position.position_label = position.position_label.trim();
      return position;
    });
  };
  const updateContent = useCallback(() => {
  }, []);

  useEffect(() => {
    updateContent();
    const interval = setInterval(() => {
      updateContent();
    }, 600000);
    return () => clearInterval(interval);
  }, [updateContent]);

  const process_positions = (untrackedPosition: PositionSecured[]) => {
    var filtered = trimSpacesInPositionLabels(untrackedPosition)
    if (positionFilter !== "") {
      filtered = filtered.filter((entry) =>
        entry.position_label
          .toLocaleUpperCase()
          .includes(positionFilter.toLocaleUpperCase())
      );
    }
    if (palletFilter !== "") {
      filtered = filtered.filter((entry) => {
        const label = entry.pallet_label ?? "empty";
        return label.toLocaleUpperCase().includes(palletFilter.toLocaleUpperCase());
      });
    }
    if (statusFilter.length > 0) {
      filtered = filtered
      filtered = filtered
      .filter((entry) => statusFilter.includes(entry.security_status))
      .sort((a, b) => statusFilter.indexOf(a.security_status) - statusFilter.indexOf(b.security_status));
    }
    return filtered;
  }

  return (
    <>
      <Row
        gutter={[30, 16]}
        align="bottom"
        justify="center"
        style={{
          padding: "10px 20px",
        }}
      >
        <Col xs={24} sm={24} md={24} lg={24} >
          <PositionsControls onApply={onApplyFilters} classes={props.classes}/>
        </Col>
      </Row>
      <Divider />
      <SummaryTable
        updateContent={updateContent}
        positions={process_positions(props.positionSecured)}
        sweepId={sweepId ? parseInt(sweepId) : 0}
        classes={props.classes}
      />
    </>
  );
};

export default Positions;